// ─────────────────────────────────────────────────────────────────────────────
// campoTocavel — tocar num campo ABRE o campo. Sempre.
//
// ── POR QUE ISTO EXISTE ──────────────────────────────────────────────────────
//
// Abrir o teclado é, no fim, uma coisa só: o campo ficar com o foco durante o
// gesto da pessoa. Tudo o que acontece no app entre o dedo e o foco pode
// desfazer isso — um overlay que ainda está saindo e puxa o foco de volta para
// si, um `preventDefault()` de gesto que cancela o clique sintético, um
// re-render que troca o nó no meio do caminho. Cada um desses é um defeito e é
// corrigido no lugar dele (ver SwipeableOffcanvas e edgeSwipeManager); este
// módulo é a garantia de que, mesmo que apareça um quarto, o campo abre.
//
// Não é sutil e não tenta ser: no fim do toque, se o campo ainda não está com o
// foco, ele recebe. É CHEIO de rede:
//
//  ▸ no `pointerup`, não no `pointerdown` — focar na descida faria o teclado
//    pular na cara de quem só passou o dedo pela tela para rolar a lista;
//  ▸ só quando o dedo praticamente não andou (`FOLGA_TOQUE`), pelo mesmo
//    motivo;
//  ▸ ainda dentro do gesto, que é a condição que o iOS exige para abrir o
//    teclado a partir de um `focus()` de código;
//  ▸ e uma única reafirmação no quadro seguinte, porque o ladrão de foco
//    conhecido (o `enforceFocus` do react-bootstrap) rouba num `setTimeout`,
//    logo DEPOIS do nosso foco. Reafirmar duas vezes seria brigar com um blur
//    legítimo; uma vez cobre o caso real.
//
// Uso:
//
//   import { campoTocavel } from '../../utils/campoTocavel';
//   <input {...campoTocavel} value={…} onChange={…} />
//
// O objeto traz só handlers de ponteiro, então ele convive com qualquer
// `onChange`/`onBlur` do campo. Espalhe-o ANTES dos seus próprios handlers de
// ponteiro, se tiver algum, para poder sobrescrever.
// ─────────────────────────────────────────────────────────────────────────────

/** Acima disto o toque foi um arraste (rolagem), não um toque no campo. */
const FOLGA_TOQUE = 10;

// Um ponteiro por vez é o que existe num telefone; guardar por id evitaria um
// caso que não acontece e esconderia este módulo atrás de um Map.
let inicioX = null;
let inicioY = null;

function focar(el) {
  if (!el || !el.isConnected || el.disabled || el.readOnly) return;
  if (document.activeElement === el) return;
  try {
    el.focus({ preventScroll: true });
  } catch (_) {
    // `preventScroll` não é universal; o foco importa mais que a rolagem.
    el.focus();
  }
}

function aoDescer(e) {
  inicioX = e.clientX;
  inicioY = e.clientY;
}

function aoSubir(e) {
  const el = e.currentTarget;
  if (inicioX == null || inicioY == null) {
    inicioX = null;
    inicioY = null;
    return;
  }
  const dx = Math.abs(e.clientX - inicioX);
  const dy = Math.abs(e.clientY - inicioY);
  inicioX = null;
  inicioY = null;
  if (dx > FOLGA_TOQUE || dy > FOLGA_TOQUE) return;

  focar(el);
  // O ladrão conhecido age num `setTimeout(…, 0)`; um quadro depois já passou.
  requestAnimationFrame(() => focar(el));
}

function aoCancelar() {
  inicioX = null;
  inicioY = null;
}

/** Props para espalhar num <input>/<textarea>. */
export const campoTocavel = {
  onPointerDown: aoDescer,
  onPointerUp: aoSubir,
  onPointerCancel: aoCancelar,
};

export default campoTocavel;
